import React from 'react'

import CreateNewCollectionForm from './createNewCollectionForm'
import AddItemToCollectionList from './addItemToCollectionList'
import { logError } from '../../../../common/utils/errors'

export default ({
  openModalData: {
    item
  },
  collections,
  modalMessages,
  deleteBookmark,
  addBookmark,
  showModalMessage,
  dismissModalMessage,
  createCollection,
  closeModal
}) => {
  const onCloseClick = (event) => {
    event.preventDefault()
    closeModal()
  }

  const onToggleItemInCollectionModal = (event, collection, item) => {
    event.preventDefault()
    const isItemInCollection = !!collection.bookmarks[item.id]
    if (isItemInCollection) {
      const bookmark = collections[collection.id].bookmarks[item.id]
      if (bookmark.id && bookmark.optimisticStatus !== 'pending') {
        deleteBookmark(collection.id, item.id, bookmark.id)
      }
    } else {
      addBookmark(collection.id, item.id)
    }
  }

  const onCreateNewCollectionFormSubmit = (collectionName, collectionIsPublic) => {
    return createCollection({
      name: collectionName,
      isPublic: collectionIsPublic
    })
      .then((action) => {
        if (action && action.type === 'createCollectionSuccess') {
          dismissModalMessage()
          const newColectionId = action.payload.id
          return addBookmark(newColectionId, item.id)
        }
      }).catch(logError)
  }

  const renderCollectionList = (collections) => {
    const collectionsIDsWithoutFavouriteCollection = Object.keys(collections)
      .filter((collectionId) => {
        return collections[collectionId].special_role !== 'favorite'
      })

    return collectionsIDsWithoutFavouriteCollection.length > 0
      ? collectionsIDsWithoutFavouriteCollection
        .map((collectionId) => {
          return collections[collectionId]
        })
        .map((collection, index) => {
          return (
            <AddItemToCollectionList
              collection={collection}
              item={item}
              index={index}
              key={index}
              onToggleItemInCollectionModal={onToggleItemInCollectionModal}
            />
          )
        })
      : <li><p className='fds-c-text-body -size-s -color-mid fds-u-mt4 fds-u-text-align-center'>You have no Collections yet</p></li>
  }

  return (
    <div className='fds-c-modal -width-m modal'>
      <header className='fds-c-modal__header'>
        <h2 className='fds-c-text-heading -size-m fds-u-mb1'>Add this Item to a Collection</h2>
        <p className='fds-c-text-body -size-s -weight-bold'>{item.name}</p>
        <a title='Close' className='fds-c-modal__close' onClick={onCloseClick}>
          <i className='fds-c-icon -icon-cancel -color-grey-medium -size-small'>
            <span className='fds-c-icon__alt'>Close</span>
          </i>
        </a>
      </header>
      <div className='fds-c-modal__section -padding-none -height-scroll collection__list'>
        <ul className='fds-c-text-list -style-none'>
          {renderCollectionList(collections)}
        </ul>
      </div>
      <CreateNewCollectionForm
        onCreateNewCollectionFormSubmit={onCreateNewCollectionFormSubmit}
        modalMessages={modalMessages}
        dismissModalMessage={dismissModalMessage}
        showModalMessage={showModalMessage}
      />
      <footer className='fds-c-modal__footer'>
        <div className=''>
          <p className='fds-c-text-body -size-s fds-u-mb0 fds-u-mt1'>
            <a href='/collections/manage' className='fds-c-text-link -weight-normal -decoration-none'>
              <i className='fds-c-icon -icon-cog' /> Manage my Collections
            </a>
          </p>
        </div>
        <a href='#' className='fds-c-button--3d -color-primary' onClick={onCloseClick}>Great, I'm done</a>
      </footer>
    </div>
  )
}



// WEBPACK FOOTER //
// ./client/components/modals/collection/addItemToCollection.js